import { useRouter } from '@tanstack/react-router'

// Default back action for top bars: go back in history, or — when there is no
// earlier entry (deep link, fresh tab, push-notification open) — fall back to
// the home screen instead of doing nothing.
export function useBackOrHome() {
  const router = useRouter()
  return () => {
    if (router.history.canGoBack()) {
      router.history.back()
    } else {
      void router.navigate({ to: '/home' })
    }
  }
}
